// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","463":"component---src-templates-default-js"}[chunkId] + "-" + {"125":"1179f2d634fa7cb5a7f9","463":"0ecc4330ed39416736d7"}[chunkId] + ".js";
};